import { DateTime } from 'luxon'
import { IIdentifiable } from '@/common/models/models'
import { ISchedulePeriod, SchedulePeriod } from '@/common/models/data/dashboard/schedule/schedule-period'

interface ISchedule extends IIdentifiable {
    day: number
    period_id: number
    start_hour: string
    end_hour: string
    title: string
    description: string | null
    person: boolean
    schedule_image: string | null
    player_image: string | null

    period?: ISchedulePeriod
}

class Schedule implements ISchedule {
    id = 0
    day = 1
    period_id = 0
    start_hour = ''
    end_hour = ''
    title = ''
    description: string | null = null
    person = false
    schedule_image: string | null = null
    player_image: string | null = null

    period?: SchedulePeriod = undefined

    scheduleFile: File | null = null
    playerFile: File | null = null

    constructor (dto?: ISchedule) {
        if (dto) {
            this.id = dto.id
            this.period_id = dto.period_id
            this.day = dto.day
            this.start_hour = dto.start_hour.substring(0, 5)
            this.end_hour = dto.end_hour.substring(0, 5)
            this.title = dto.title
            this.description = dto.description
            this.person = dto.person
            this.schedule_image = dto.schedule_image
            this.player_image = dto.player_image

            this.period = dto.period ? new SchedulePeriod(dto.period) : undefined
        }
    }

    get start (): DateTime {
        return DateTime.fromFormat(this.start_hour, 'HH:mm')
    }

    get end (): DateTime {
        return DateTime.fromFormat(this.end_hour, 'HH:mm')
    }

    get started (): boolean {
        return this.start < DateTime.local()
    }

    get notFinished (): boolean {
        return this.end >= DateTime.local()
    }

    get passed (): boolean {
        const currentDay = DateTime.local().weekday
        const alreadyStarted = this.start < DateTime.local() && this.day === currentDay
        const dayPassed = this.day < currentDay

        return alreadyStarted || dayPassed
    }

    get isOverlapping (): boolean {
        return this.end < this.start
    }
}

export {
    ISchedule, Schedule
}
